const TrustIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 25 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g
        id="Icons-/-Line-/-Refer-a-Friend-(trust)"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <path
          d="M1,18.9438023 L5.26361917,23.2134758 L6.75254856,21.7465455 C6.93963902,21.5622193 7.19173475,21.4588952 7.45437324,21.4588952 L16.8948468,21.4588952 L16.8948468,21.4588952 L23.6980754,14.6009875 C24.0026257,14.2940032 24.0753491,13.8260428 23.8783346,13.441107 C23.8060162,13.299808 23.7237024,13.1830432 23.6313933,13.0908126 C23.5190974,12.9786123 23.3657049,12.8764386 23.1712157,12.7842915 C22.7972497,12.6071464 22.3527997,12.6786018 22.0532266,12.9640609 L17.1845401,17.6033663 C16.9985791,17.780566 16.7515612,17.8794111 16.4946931,17.8794111 L11.9408054,17.8794111 L11.9408054,17.8794111 L10.97468,17.0816416 L14.7558117,16.1662831 C15.2045025,16.0576614 15.5205224,15.6560093 15.5205224,15.1943578 L15.5205224,14.7520177 C15.5205224,14.199733 15.0728071,13.7520177 14.5205224,13.7520177 L6.50622564,13.7520177 C6.23743976,13.7520177 5.97997013,13.8602212 5.79187658,14.0522281 L1,18.9438023 L1,18.9438023 Z"
          id="Path-2"
          fill="white"></path>
        <path
          d="M15.9288242,11.2800744 L11.1104688,6.72301902 C11.0471265,6.66315736 10.991907,6.59525123 10.9461911,6.52105065 C10.0761703,5.10893595 9.79687738,3.96446652 10.1083123,3.08764238 C10.5879433,1.7372733 11.5634403,1 13.0185682,1 C13.9886536,1 14.9587389,1.69588079 15.9288242,3.08764238 C16.8316293,1.69588079 17.7492154,1 18.6815826,1 C20.0801334,1 20.9163738,1.61101729 21.4906562,3.08764238 C22.0649386,4.56426747 21.666018,5.46674743 20.8730383,6.63478571 C20.3443851,7.41347789 18.6963138,8.96190747 15.9288242,11.2800744 Z"
          id="Path-3"
          fill="white"></path>
      </g>
    </svg>
  );
};

export default TrustIcon;
